import { jsx as e, jsxs as x } from "react/jsx-runtime";
import s from "react";
import { Spinner as h, Box as g, Link as z, FlexBox as T, Typography as y } from "@vp/swan";
import { useArticle as L } from "./help-center-knowledge-anatomies6.js";
import { LastModifiedDate as v } from "./help-center-knowledge-anatomies3.js";
import { LocalizationProvider as C } from "./help-center-knowledge-anatomies4.js";
import { LocalizationContext as D } from "./help-center-knowledge-anatomies5.js";
import { getLocalizationResource as I } from "./help-center-knowledge-anatomies8.js";
const M = ({ articleNumber: l, locale: n, className: c, onArticleLoad: o, onArticleError: i, useStaging: u }) => {
  const { article: t, loading: r, error: a } = L(l, n, u), d = s.useContext(D);
  if (s.useEffect(() => {
    t && o && o(t);
  }, [t, o]), s.useEffect(() => {
    if (!i) return;
    let f = null;
    return a ? i(!0) : t ? i(!1) : r || (f = setTimeout(() => {
      i(!0);
    }, 500)), () => {
      f && clearTimeout(f);
    };
  }, [a, t, r, i, l]), r)
    return /* @__PURE__ */ e("div", { className: c || "", children: /* @__PURE__ */ e(h, { accessibleText: "Loading article..." }) });
  if (a || !t)
    return null;
  const m = /* @__PURE__ */ e(g, { className: c, style: { width: "max-content" }, children: /* @__PURE__ */ e(z, { href: t.articleUrl, skin: "unstyled", children: /* @__PURE__ */ x(T, { flexDirection: "column", gap: "4", alignItems: "start", children: [
    /* @__PURE__ */ e(v, { article: t, locale: n, tenant: "vistaprint" }),
    /* @__PURE__ */ e(y, { fontSize: "standard", fontWeight: "bold", children: t.articleTitle })
  ] }) }) });
  if (d)
    return m;
  const p = I(n);
  return /* @__PURE__ */ e(C, { locale: n, localizationData: p, children: m });
};
export {
  M as ArticleItem,
  M as default
};
//# sourceMappingURL=help-center-knowledge-anatomies2.js.map
